<template>
  <div class="top-banner" :style="{ 'background-image': `url(${backgroundImage})` }">
    <div class="top-banner-box">
      <div class="tips-text">Best Airfares Guaranteed</div>
      <!-- <div class="top-banner-navs">
        <div class="top-banner-nav" :class="{ active: true }">
          <svg
            t="1677903213048"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="13172"
            width="25"
            height="25"
          >
            <path
              d="M512 608.3079436L801.06525215 319.24269145s48.1539718-48.1539718 0-96.3079436-96.3079436 0-96.3079436 0l-168.64496731 168.64496731L174.71006537 319.24269145l-48.15397179 48.1539718 289.06525214 144.53262607-134.91597385 134.91597385-130.10764773-14.42497833-48.1539718 48.15397179L271.08871965 752.91128035l72.26631304 168.57425664 48.1539718-48.1539718-14.42497834-130.10764774L512 608.3079436z"
              p-id="13173"
              fill="$color"
            ></path>
            <path
              d="M704.75730855 849.28993463L639.34993129 522.53589104l-113.49063838 113.49063838 130.74404384 261.417377z"
              p-id="13174"
              fill="$color"
            ></path>
          </svg>
          <span>Flights</span>
        </div>
      </div> -->
      <top-form :dataForm="dataForm" :markPage="markPage"></top-form>
    </div>
  </div>
</template>

<script>
import TopForm from "../topForm/topForm.vue"
export default {
  name: "topBanner",
  data() {
    return {
      dataForm: {},
      markPage: "首页",
    }
  },
  created() {
    this.dataForm = JSON.parse(sessionStorage.getItem("searchForm"))
  },
  computed: {
    backgroundImage() {
      return (process.env.NODE_ENV === "development" ? "/api" : "") + "/v2/static/background"
    },
  },
  components: {
    TopForm,
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "./topBanner.scss";
@import "./mtopBanner.scss";
</style>
